export const MuiTabs = {
  styleOverrides: {
    indicator: {
      backgroundColor: 'rgba(34, 40, 34, 1)',
    },
  },
};
